import { useContent } from "@/content/ContentProvider";
import React from "react";
import { ArrowDown } from "lucide-react";
import { Reveal, WordTitle } from "./Reveal";
import { PillButton } from "./Kit";
import ShaderBackground from "./ShaderBackground";
export function Hero() {
  const { text: cmsText, nextLayout } = useContent();
  return (
    <section
      id="hero"
      className="relative overflow-hidden bg-[#f7f7f7] px-3 pb-3 pt-24 sm:px-5 sm:pb-5"
      data-testid="hero"
    >
      <ShaderBackground strength={0.36} lines={13} fadeLeft={0.8} />
      <div className="relative z-10 mx-auto flex min-h-[calc(100vh-120px)] max-w-[1400px] flex-col justify-between">
        <div className="hidden justify-end pt-6 sm:flex sm:pt-10">
          <Reveal
            delay={800}
            className="w-full max-w-[300px] rounded-[20px] bg-white/95 p-5 backdrop-blur-sm"
          >
            <p className="text-[12px] opacity-50">
              {cmsText("HomeTop.Hero.a-connected-workflow-example.ee38f7")}
            </p>
            <div className="mt-5 space-y-3">
              {[
                cmsText("HomeTop.Hero.information-received.625d26"),
                cmsText("HomeTop.Hero.work-prepared.7f0d77"),
                cmsText("HomeTop.Hero.human-review.40176d"),
              ].map((label, i) => (
                <div
                  key={label}
                  className="flex items-center gap-3 text-[16px] tracking-[-0.02em]"
                >
                  <span className="text-[11px] tabular-nums opacity-35">
                    0{i + 1}
                  </span>
                  <span>{label}</span>
                  {i < 2 && (
                    <ArrowDown
                      size={12}
                      className="ml-auto opacity-30"
                      aria-hidden="true"
                    />
                  )}
                </div>
              ))}
            </div>
            <PillButton
              href={nextLayout ? "#monday" : "#method"}
              variant="light"
              className="mt-5"
            >
              {cmsText("HomeTop.Hero.how-it-works.1dd6a1")}
            </PillButton>
          </Reveal>
        </div>
        <div className="mt-auto pb-6 pt-16 sm:pb-10 sm:pt-24">
          <Reveal
            delay={200}
            className="mb-5 text-[13px] font-medium opacity-60"
          >
            {cmsText("HomeTop.Hero.nomus-connected-internal-tools.b3096b")}
          </Reveal>
          <WordTitle
            text={cmsText("HomeTop.Hero.make-ai-normal-.916c06")}
            className="max-w-[1100px] text-[58px] leading-[0.94] sm:text-[96px] lg:text-[144px]"
          />
          <Reveal
            delay={900}
            className="mt-6 max-w-[720px] text-[22px] leading-[1.2] tracking-[-0.025em] sm:text-[30px]"
          >
            {cmsText(
              "HomeTop.Hero.we-build-connected-internal-tools-that-let-yo.357edf",
            )}
          </Reveal>
          <div className="mt-10 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <Reveal delay={1100} className="flex flex-wrap items-center gap-2">
              <PillButton
                to={nextLayout ? "/scorecard" : "/contact"}
                size="lg"
                data-testid="hero-cta"
              >
                {cmsText("HomeTop.Hero.discuss-your-workflow.184fa5")}
              </PillButton>
              <PillButton
                href={nextLayout ? "#monday" : "#audiences"}
                variant="white"
                size="lg"
                data-testid="hero-audiences"
              >
                {cmsText("HomeTop.Hero.explore-workflows.4933f1")}
              </PillButton>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
